import API from './api';
import { handleApiError } from './utilsService';

// Servicio para el monedero
const walletService = {
  // Obtener el saldo del monedero
  getBalance: async () => {
    try {
      const response = await API.get('/wallet/balance');
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener el saldo del monedero');
    }
  },

  // Obtener el historial de transacciones
  getTransactions: async (filters = {}) => {
    try {
      const response = await API.get('/wallet/transactions', { params: filters });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener el historial de transacciones');
    }
  },

  // Obtener transacciones detalladas con información de PostgreSQL
  getDetailedTransactions: async (filters = {}) => {
    try {
      const response = await API.get('/wallet/transactions-detailed', { params: filters });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener las transacciones detalladas');
    }
  },

  // Obtener una transacción por ID
  getTransactionById: async (id) => {
    try {
      const response = await API.get(`/wallet/transactions/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener la transacción');
    }
  },

  // Añadir fondos al monedero
  addFunds: async (amount, paymentMethod) => {
    try {
      const response = await API.post('/wallet/add-funds', { amount, paymentMethod });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al añadir fondos al monedero');
    }
  },

  // Retirar fondos del monedero
  withdrawFunds: async (amount, withdrawalMethod) => {
    try {
      const response = await API.post('/wallet/withdraw', { amount, withdrawalMethod });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al retirar fondos del monedero');
    }
  },

  // Transferir fondos a otro usuario
  transferFunds: async (recipientId, amount, description) => {
    try {
      const response = await API.post('/wallet/transfer', { recipientId, amount, description });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al transferir fondos');
    }
  },

  // Pagar un partido
  payMatch: async (matchId, amount) => {
    try {
      const response = await API.post('/wallet/pay-match', { matchId, amount });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al pagar el partido');
    }
  },

  // Obtener métodos de pago guardados
  getSavedPaymentMethods: async () => {
    try {
      const response = await API.get('/wallet/payment-methods');
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener los métodos de pago guardados');
    }
  },

  // Añadir un método de pago
  addPaymentMethod: async (paymentMethodData) => {
    try {
      const response = await API.post('/wallet/payment-methods', paymentMethodData);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al añadir el método de pago');
    }
  },

  // Eliminar un método de pago
  removePaymentMethod: async (paymentMethodId) => {
    try {
      const response = await API.delete(`/wallet/payment-methods/${paymentMethodId}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al eliminar el método de pago');
    }
  },

  // Establecer un método de pago como predeterminado
  setDefaultPaymentMethod: async (paymentMethodId) => {
    try {
      const response = await API.put(`/wallet/payment-methods/${paymentMethodId}/default`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al establecer el método de pago predeterminado');
    }
  },

  // Obtener una factura por ID
  getInvoice: async (invoiceId) => {
    try {
      const response = await API.get(`/wallet/invoices/${invoiceId}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener la factura');
    }
  },

  // Obtener todas las facturas
  getInvoices: async (filters = {}) => {
    try {
      const response = await API.get('/wallet/invoices', { params: filters });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener las facturas');
    }
  },

  // Descargar una factura en PDF
  downloadInvoice: async (invoiceId) => {
    try {
      const response = await API.get(`/wallet/invoices/${invoiceId}/download`, {
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al descargar la factura');
    }
  },

  // Verificar el estado de un pago
  checkPaymentStatus: async (paymentId) => {
    try {
      const response = await API.get(`/wallet/payments/${paymentId}/status`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al verificar el estado del pago');
    }
  },
};

export default walletService;
